'use client';

import type { MysteryRoomVec2 } from '../world/mapTypes';

export type MysteryRoomMoveKeyState = {
  up?: boolean;
  down?: boolean;
  left?: boolean;
  right?: boolean;
  upAlt?: boolean;
  downAlt?: boolean;
  leftAlt?: boolean;
  rightAlt?: boolean;
};

export const MYSTERY_ROOM_KEYBOARD_BINDINGS = {
  primaryInteract: 'KeyE',
  carry: 'KeyF',
  weapon: 'KeyQ',
  flashlight: 'KeyT',
  inventory: 'Tab',
} as const;

export function normalizeInputVector(input: MysteryRoomVec2): MysteryRoomVec2 {
  const length = Math.hypot(input.x, input.y);
  if (length <= 0.0001) {
    return { x: 0, y: 0 };
  }

  return {
    x: input.x / length,
    y: input.y / length,
  };
}

export function resolveMysteryRoomActionBarHotkeyIndex(code: string): number | null {
  if (!/^Digit[1-5]$/.test(code)) {
    return null;
  }
  return Number(code.slice(-1)) - 1;
}

export function mysteryRoomMoveVectorFromKeys(keys: MysteryRoomMoveKeyState): MysteryRoomVec2 {
  return {
    x: (keys.right || keys.rightAlt ? 1 : 0) - (keys.left || keys.leftAlt ? 1 : 0),
    y: (keys.down || keys.downAlt ? 1 : 0) - (keys.up || keys.upAlt ? 1 : 0),
  };
}
